import BasePage from "./BasePage";
import { Component, Watch } from "vue-property-decorator";
import _ from "lodash";
import { InForceCaseData } from "@/models/InForceCaseData";
import { inForceStore } from "@/store/modules/InForceStore";

@Component
export default class InForceBase extends BasePage {
  state: InForceCaseData = _.cloneDeep(inForceStore.current);

  get currentState(): InForceCaseData {
    return _.cloneDeep(inForceStore.current);
  }

  @Watch("currentState")
  onStateChanged(newVal: InForceCaseData): void {
    this.state = newVal;
  }
}
